import { SESSION } from "../../models/custom"
import { DataProviderRequestError } from "./data-provider.error"

export class DataProviderRequest<TResult> {

    //#region Members

    private promise: JQueryPromise<TResult>
    private cancelled: boolean

    //#endregion

    //#region Ctor

    public constructor() {
        this.cancelled = false
    }

    //#endregion

    //#region Promise Like API

    public then(func: (result: TResult) => any) {
        return this
            .toPromise()
            .then((result: TResult) => {
                if (func != null) {
                    return func(result)
                }
            })
    }

    public catch(func: (error: DataProviderRequestError) => any) {
        return this
            .toPromise()
            .fail((error: DataProviderRequestError) => {
                if (func != null) {
                    return func(error)
                }
            })
    }

    public always(func: () => any) {
        return this
            .toPromise()
            .always(() => {
                if (func != null) {
                    return func()
                }
            })
    }

    //#endregion

    //#region Utils

    public map<TMappedResult>(func: (result: TResult) => TMappedResult): DataProviderRequest<TMappedResult> {
        const promise = this.promise.then((result: TResult) => {
            return func(result)
        })

        const request = DataProviderRequest.fromJQuery(promise)

        request.cancelled = this.cancelled

        return request
    }

    public tap(func: (result: TResult) => void): this {
        this.promise.then((result: TResult) => {
            return func(result);
        })

        return this;
    }

    public tapError(func: (error: DataProviderRequestError) => void): this {
        this.promise.catch((error: DataProviderRequestError) => {
            return func(error);
        })

        return this;
    }

    //#endregion

    //#region toPromise()

    public toPromise(): JQueryPromise<TResult> {
        const deferred = $.Deferred<TResult>()

        if (this.promise != null) {
            this.promise
                .then((result: TResult) => {
                    if (this.cancelled === false) {
                        deferred.resolve(result)
                    }
                })
                .fail((error: SESSION) => {
                    if (this.cancelled === false) {
                        deferred.reject(DataProviderRequestError.fromSESSION(error))
                    }
                })
        }

        return deferred.promise()
    }

    //#endregion

    //#region Cancel

    public cancel(): void {
        this.cancelled = true
    }

    //#endregion

    //#region Factory

    public static fromJQuery<TResult>(deferred: JQueryPromise<TResult>): DataProviderRequest<TResult> {
        if (deferred != null) {
            const request = new DataProviderRequest<TResult>()

            request.promise = deferred

            return request
        }

        return null
    }

    public static fromValue<TResult>(value: TResult): DataProviderRequest<TResult> {
        return this.fromJQuery($.Deferred().resolve(value).promise())
    }

    //#endregion
}